import React from "react"
import OverviewQuote from "./variations/OverviewQuote"
import OverviewStats from "./variations/OverviewStats"
import OverviewCombined from "./variations/OverviewCombined"
import OverviewComponent from "./variations/OverviewComponent"

const OverviewController = ({ content }) => {
  console.log(content);
  
  const component = content?.variation

  switch (component) {
    case "Quote":
      return <OverviewQuote content={content?.overviewQuote} />
    case "Stats":
      return <OverviewStats content={content?.overviewStats} />

    case "Overview":
      return <OverviewComponent content={content?.overviewOverview} />

    case "Combined":
      return (
        <OverviewCombined
          content={{
            quote: content?.overviewQuote,
            stats: content?.overviewStats,
          }}
        />
      )
  }
}

export default OverviewController
